import { createStore } from 'zustand-x';
import jwtDecode from 'jwt-decode';

interface AuthStore {
  tokens:
    | {
        access: string;
        refresh: string;
      }
    | undefined;
  isLogged: boolean;
  claims: Claims | undefined;
  isUserLogOut: boolean;
}

export type Claims = {
  id: string;
  role: string;
  orgId: string;
};

interface JwtPayload extends Claims {
  expires: number;
}

export const authStore = createStore('auth')<AuthStore>(
  {
    isLogged: false,
    tokens: undefined,
    claims: undefined,
    isUserLogOut: false,
  },
  {
    devtools: { enabled: true },
    persist: {
      enabled: true,
      name: 'csir-tokens',
    },
  }
).extendActions((set) => ({
  setTokens: (accessToken: string, refreshToken: string) => {
    if (accessToken === '' || refreshToken === '') {
      throw new Error('Empty access/refresh tokens');
    }
    const claims = jwtDecode<JwtPayload>(accessToken);
    set.state((state) => ({
      ...state,
      tokens: { access: accessToken, refresh: refreshToken },
      claims,
      isLogged: true,
      isUserLogOut: false,
    }));
  },
  removeTokens: () => {
    set.state(() => ({
      isUserLogOut: false,
      isLogged: false,
      tokens: undefined,
      claims: undefined,
    }));
  },
  logoutUser: () => {
    set.state(() => ({
      isUserLogOut: true,
      isLogged: false,
      tokens: undefined,
      claims: undefined,
    }));
  },
}));
